module.exports = __webpack_public_path__ + "img/comment_img1.c55ab315.jpg";